'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _actions = require('./actions');

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var DEFAULT_CLIENT_CONFIG = {
  loginProcessRunning: false,
  isLoggedIn: false,
  token: null,
  idToken: null,
  error: null,
  refreshTokenPromise: null,
  iamConfig: null
};

var INITIAL_STATE = {
  clients: {}
};

function updateClientIdValues(clientId, state, newValues) {
  return _extends({}, state, {
    clients: _extends({}, state.clients, _defineProperty({}, clientId, _extends({}, DEFAULT_CLIENT_CONFIG, state.clients[clientId], newValues)))
  });
}

var auth = function auth() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
  var action = arguments[1];

  var clientId = action.clientId;
  switch (action.type) {
    case _actions.UPDATE_IAM_CONFIG:
      return updateClientIdValues(clientId, state, {
        iamConfig: action.iamConfig
      });
    case _actions.LOGIN_STARTED:
    case _actions.LOGOUT_STARTED:
      return updateClientIdValues(clientId, state, {
        loginProcessRunning: true
      });
    case _actions.LOGIN_SUCCESS:
    case _actions.REFRESHING_TOKEN_SUCCESS:
      return updateClientIdValues(clientId, state, {
        isLoggedIn: true,
        loginProcessRunning: false,
        token: action.token,
        idToken: action.idToken,
        error: null,
        refreshTokenPromise: null
      });
    case _actions.LOGIN_FAILURE:
    case _actions.REFRESHING_TOKEN_FAILURE:
    case _actions.LOGOUT_SUCCESS:
    case _actions.LOGOUT_FAILURE:
      return updateClientIdValues(clientId, state, {
        isLoggedIn: false,
        loginProcessRunning: false,
        token: null,
        idToken: null,
        error: action.error,
        refreshTokenPromise: null
      });
    case _actions.REFRESHING_TOKEN_STARTED:
      return updateClientIdValues(clientId, state, {
        refreshTokenPromise: action.refreshTokenPromise
      });
    default:
      return state;
  }
};

exports.default = auth;